export interface IAgent {
  org_id: string;
  _id: string;
  agent_name: string;
  agent_description: string;
  direction: "outbound" | "inbound";
  model_framework: string;
  LLM: string;
  voice: string;
  language: string;
  tool?: number[];
  knowledge_base_ids: {
    _id: string;
    company_id: string;
    file_name: string;
    base_knowledge_file_url: string;
    presigned_url: string;
  }[];
  greeting_message: string;
  system_message: string;
  voicemail_message?: string;
  voice_configs?: {
    model_framework?: string;
    voice?: string;
    tts_provider?: string;
    stt_provider?: string;
    greeting_message?: string;
    voicemail_message?: string;
    ending_message?: string;
  };
  parameters?: {
    system_variables: { [key: string]: string };
    custom_variables: { [key: string]: string };
  };
  rag_configs?: {
    pinecone?: {
      embedding_model?: string;
      index_name?: string;
      index_host?: string;
    };
    openai?: {
      vector_ids?: any[];
    };
  };
  stats: {
    number_of_calls: number;
    average_duration: string;
    completion_rate: string;
    total_second: number;
  };
  createdAt: string;
}

export interface ICreateAgent {
  org_id: string;
  agent_name: string;
  agent_description: string;
  direction: "outbound" | "inbound";
  model_framework?: string;
  LLM?: string;
  language?: string;
  tool?: number[];
  knowledge_base_ids?: string[];
  system_message: string;
  voice_configs: {
    model_framework?: string;
    voice?: string;
    tts_provider?: string;
    stt_provider?: string;
    greeting_message: string;
    voicemail_message?: string;
    ending_message?: string;
  };
  rag_configs?: {
    pinecone?: {
      embedding_model?: string;
      index_name?: string;
      index_host?: string;
    };
    openai?: {
      vector_ids?: any[];
    };
  };
  parameters?: {
    system_variables?: { [key: string]: string };
    custom_variables: { [key: string]: string };
  };
}

export interface IUpdateAgent {
  agent_name?: string;
  agent_description?: string;
  direction?: "outbound" | "inbound";
  model_framework?: string;
  LLM?: string;
  language?: string;
  system_message?: string;
  voice_configs?: {
    model_framework?: string;
    voice?: string;
    tts_provider?: string;
    stt_provider?: string;
    greeting_message?: string;
    voicemail_message?: string;
    ending_message?: string;
  };
  tool?: number[];
  knowledge_base_ids?: string[];
  rag_configs?: {
    pinecone?: {
      embedding_model?: string;
      index_name?: string;
      index_host?: string;
    };
    openai?: {
      vector_ids?: any[];
    };
  };
  parameters?: {
    system_variables?: { [key: string]: string };
    custom_variables?: { [key: string]: string };
  };
}

export interface IGetAgents {
  limit: number;
  page: number;
  keyword: string;
  direction?: "outbound" | "inbound";
  sort?: Record<string, 1 | -1>;
}

export const AGENTS_VOICE = [
  {
    name: "alloy",
    value: "alloy",
  },
  {
    name: "ballad",
    value: "ballad",
  },
  {
    name: "coral",
    value: "Ashley",
  },
  {
    name: "sage",
    value: "gJx1vCzNCD1EQHT212Ls",
  },
  {
    name: "chole",
    value: "933563129e564b19a115bedd57b7406a",
  },
  {
    name: "edgar",
    value: "fQj4gJSexpu8RDE2Ii5m",
  }
  // {
  //   name: "ndivia",
  //   value: "English-US.Female-1",
  // },
];

export const TOOL_TYPE_GROUPS = [
  { value: "general", label: "General" },
  { value: "customize", label: "Customize" },
  { value: "internal", label: "Internal" },
];
